import { APIService } from "src/services/apiService";
import { AuthenticationService } from "src/services/authenticationService";
import {
  PostUserAccountRequestBody,
  PatchUserAccountRequestBody,
  User,
  PostAccountRequestRequestBody
} from "src/types";

class UserAccountAPIService extends APIService {
  constructor(authenticationService: AuthenticationService) {
    super(authenticationService, "/v1/users");
  }

  async getUserAccountByEmail(email: string): Promise<User> {
    const pathParam = encodeURIComponent(email);
    const path = `/${pathParam}/account`;
    return await this.jwtRequest("GET", path);
  }

  async patchUserAccount(userId: string, requestBody: PatchUserAccountRequestBody): Promise<User> {
    const pathParam = encodeURIComponent(userId);
    const path = `/${pathParam}/account`;
    return await this.jwtRequest("PATCH", path, requestBody);
  }

  async patchUserAccountDeactivation(userId: string): Promise<User> {
    const pathParam = encodeURIComponent(userId);
    const path = `/${pathParam}/account/deactivation`;
    return await this.jwtRequest("PATCH", path);
  }

  async deleteUserAccount(userId: string): Promise<User> {
    const pathParam = encodeURIComponent(userId);
    const path = `/${pathParam}/account`;
    return await this.jwtRequest("DELETE", path);
  }

  async postUserAccount(requestBody: PostUserAccountRequestBody): Promise<User> {
    const path = `/account`;
    return await this.jwtRequest("POST", path, requestBody);
  }

  async postAccountRequest(requestBody: PostAccountRequestRequestBody): Promise<{ message: string }> {
    const path = `/account-request`;
    return await this.publicRequest("POST", path, requestBody);
  }

  async postPasswordResetNotification(requestBody: { email: string; userName?: string }): Promise<{ message: string }> {
    const path = `/password-reset-notification`;

    return await this.publicRequest("POST", path, requestBody);
  }
}

export { UserAccountAPIService };
